<template>
  <div :class="`ims-spinner ${color ? 'colored' : 'default'}`">
    <div>
      <svg
        class="animate spin"
        :width="size"
        :height="size"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 18C6.59587 18 4.33575 17.0668 2.63587 15.3719C0.936 13.6771 0 11.4237 0 9.02666C0 7.32957 0.478125 5.67736 1.3815 4.24723C2.25927 2.8583 3.5015 1.73534 4.97362 1L5.72962 2.50416C4.53302 3.10254 3.52315 4.01556 2.80912 5.14456C2.07482 6.30692 1.68592 7.65295 1.6875 9.02666C1.6875 13.0467 4.968 16.3175 9 16.3175C13.032 16.3175 16.3125 13.0467 16.3125 9.02666C16.3125 7.647 15.9244 6.30549 15.1909 5.14456C14.4775 4.015 13.4675 3.10183 12.2704 2.50416L13.0264 1C14.4985 1.73534 15.7407 2.8583 16.6185 4.24723C17.5226 5.67827 18.0016 7.33539 18 9.02666C18 11.4237 17.064 13.6771 15.3641 15.3719C13.6642 17.0668 11.4041 18 9 18Z"
          :fill="color"
        />
      </svg>
    </div>
    <label v-if="title">{{title}}</label>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    size: {
      type: Number,
      default() {
        return 26;
      }
    }
  }
};
</script>

<style lang="scss">
@import "../../scss/utils/variables";

.ims-spinner.default {
  svg path {
    fill: $primary;
  }
}
.ims-spinner {
  padding: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  label {
    margin: 0;
    padding: 0;
    margin-left: 10px;
    font-size: $font-sm;
    opacity: 0.8;
    font-weight: 500;
  }
}
</style>